import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutZonesQuickInfo extends Layout {
    buttonDispatchZoneCode: Button;
    panelZonesQuickInfo: Panel;
    sourceZones: DataSource;
    textboxDescr: Textbox;
    textboxParentZoneArea: Textbox;
    textboxZoneId: Textbox;
}
